/**
 * 기기 판정 유틸
 *
 * 모바일 전용 관리자(/Mobile)와 PC 관리자(/My) 분기에만 사용한다.
 * 창 너비 기반인 $vuetify.display.mobile 은 다이얼로그 전체화면 등
 * 레이아웃 처리에 그대로 쓰므로 여기서 건드리지 않는다.
 */

/**
 * 폰(스마트폰)이면 true.
 *
 * 태블릿은 PC로 취급한다.
 * - iPadOS 13+ 사파리는 기본 UA가 Macintosh 로 나와 자연히 false
 * - 안드로이드 태블릿은 UA에 Mobile 토큰이 없어 false
 */
export function isPhone(): boolean {

  if(typeof navigator === 'undefined'){
    return false;
  }

  const ua = navigator.userAgent || '';

  //아이폰 계열
  if(/iPhone|iPod/i.test(ua)){
    return true;
  }

  //안드로이드는 Mobile 토큰이 있어야 폰. 없으면 태블릿.
  if(/Android/i.test(ua) && /Mobile/i.test(ua)){
    return true;
  }

  //기타 모바일 브라우저
  if(/BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(ua)){
    return true;
  }

  return false;
}
